module.exports = __webpack_public_path__ + "img/img_industries5.99bd64a8.jpg";